// TableDigiUpload.jsx

import React from "react";
import ViewDoc from "../../assets/img/eye-icon-black.svg";
import DownloadDoc from "../../assets/img/download-icon-black.svg";
import { X } from "feather-icons-react/build/IconComponents";

// Separate component for rendering table header
const TableHeader = ({ headers }) => (
  <thead className="thead-light">
    <tr>
      {headers.map((header, index) => (
        <th key={index} scope="col">
          {header}
        </th>
      ))}
    </tr>
  </thead>
);

// Separate component for rendering table body rows
const TableBody = ({ data }) => (
  <tbody>
    {data.map((row, index) => (
      <tr key={index}>
          <td key="qualification_degree">{row?.course_name}</td>
          <td key="university_board">{row?.university_board}</td>
          {/* <td key="RROLL">{row?.digilocker_data?.RROLL}</td> */}
          <td key="YEAR">{row?.end_year}</td>
          <td key="doc_type">{row?.doc_name}</td>
          <td key="action">
          <div className="d-flex justify-content-start align-content-center">
               <span>
                 <img
                    style={{ cursor: "pointer" }}
                    src={ViewDoc}
                    alt="ViewDoc"
                    onClick={(()=>{window.open(row?.s3_file_url, '_blank')})}
                  />
                </span>{" "}
                &nbsp; &nbsp;
                <span>
                <a >
                  <img
                    style={{ cursor: "pointer" }}
                    src={DownloadDoc}
                    alt="DownloadDoc"
                    onClick={(()=>{window.open(row?.s3_file_url, '_blank')})}
                  /></a>
                </span>
              </div></td>
      </tr>
    ))}
  </tbody>
);

const TableBodyNotFetched = ({ data }) => (
  <tbody>
    {data.map((row, index) => (
      <tr key={index}>
          <td key="qualification_degree">{row?.course_name}</td>
          <td key="university_board">{row?.university_board}</td>
          {/* <td key="RROLL">{row?.digilocker_data?.RROLL}</td> */}
          <td key="YEAR">{row?.end_year}</td>
          <td key="doc_type"><div className="text-danger">
                 Not Available<sup>*</sup>
              </div></td>
          {/* <td kye="action"></td> */}
      </tr>
    ))}
  </tbody>
);

const TableBodymannual = ({row}) => (
  <tbody>
    
      <tr >
          <td key="qualification_degree">{row?.course_name}</td>
          <td key="university_board">{row?.university_board}</td>
          <td key="institute_name">{row?.institute_name}</td>
          <td key="YEAR">{row?.end_year}</td>
          <td key="doc_type">{row?.college_location}</td>
          {/* <td kye="action"></td> */}
      </tr>
   
  </tbody>
);

// Main TableDigiUpload component
function TableDigiUpload({ headers, data, type }) {
  if(type=="fetched"){
    return (
      <div class="table-responsive">
        <table className="col-12 pb-4 table w-100" style={{ overflowY: "scroll", }}>
          <TableHeader headers={headers} className="w-100" />
          <TableBody data={data} />
        </table>
      </div>
    );
  }
  if(type=="notfetched"){
    return (
      <div class="table-responsive">
        <table className="col-12 pb-4 table w-100" style={{ overflowY: "scroll", }}>
          <TableHeader headers={headers} className="w-100" />
          <TableBodyNotFetched data={data} />
        </table>
      </div>
    );
  }
  if(type=="mannual"){
    return (
      <div class="table-responsive">
        <table className="col-12 pb-4 table w-100" style={{ overflowY: "scroll", }}>
          <TableHeader headers={headers} className="w-100" />
          <TableBodymannual row={data} />
        </table>
      </div>
    );
  }
  
}

export default TableDigiUpload;
